function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBuildrzLogoInner = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 2000 2000"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "m1171.18 1088.87-342.36-99.34 342.36-99.35V491.27l-342.36 99.35-342.35-99.35v890.71l342.35 99.34 342.36 99.35 342.35-99.35V989.53l-342.35 99.34z",
  style: {
    fill: "#fff",
    fillRule: "evenodd"
  }
}));
export default SvgBuildrzLogoInner;